import { computed, observable } from 'mobx';

/**
 * Slide 页数状态管理
 */
export class SlideCountState implements ISlideCountState {
    /** SSR 初始页数据，用于首屏显示 */
    @observable private initial = NaN;
    /** SDK 页数状态，转 UI 前展示 */
    @observable private sdk = NaN;
    /** UI Model 页数状态，转 UI 后展示  */
    @observable private ui = NaN;

    /**
     * 用于展示的幻灯片页数，优先级：SSR > SDK > UI
     * @returns 页数
     * @example
     * ```ts
     * const count = SlideCountState.count;
     * ```
     */
    @computed
    public get slideCount() {
        if (!Number.isNaN(this.initial)) {
            return this.initial;
        }

        if (!Number.isNaN(this.sdk)) {
            return this.sdk;
        }

        return this.ui;
    }

    public setInitialCount(count: number) {
        this.initial = count;
    }

    public setSdkSlideCount(count: number) {
        this.initial = NaN;
        this.sdk = count;
    }

    public setUiSlideCount(count: number) {
        this.initial = NaN;
        this.sdk = NaN;
        this.ui = count;
    }
}

export interface ISlideCountState {
    slideCount: number;

    setInitialCount(count: number): void;
    setSdkSlideCount(count: number): void;
    setUiSlideCount(count: number): void;
}
